module.exports = __webpack_public_path__ + "static/media/addcomment2.464e760b.svg";